import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // The admin dashboard manages its own per-section scroll restoration.
    if (pathname.startsWith('/admin')) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
